import { CodeSection } from 'civil-status/constants/code-subject-section';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { STATES_ACT } from 'civil-status/constants/states-act';
import {
  ParentVM,
  RecapVM,
  SectionVM,
  Evento,
  TextActVM,
} from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';

export const transformerEvento = (
  data: Array<RecapVM>,
  idEvento?: number,
  idValore?: string,
  descrizioneValore?: string,
  dateFormationAct?: string,
  subject?: ParentVM,
  nascituro?: ParentVM,
  dataDead?: SectionVM,
  dataCittadinanza?: SectionVM,
  dataDatiGeneraliRiconoscimento?: SectionVM,
  dataDatiGenerali?: SectionVM,
  dataEventoRiconoscimento?: SectionVM,
  valuesText?: TextActVM,
  dataComposizioneAtto?: SectionVM,
  dataComposizioneAttoDue?: SectionVM,
  testoDelegaUnioneCivile?: SectionVM,
  testoDelegaMatrimonio?: SectionVM,
  dataTranscriptionBorn?: SectionVM,
  dataSpecificCivilUnion?: SectionVM,
  tipoDichiarante?: string,
  dataMatrimonioAtti?: SectionVM,
  dataDatiSeparazioniUC?: SectionVM,
  isLastStepEmergency?: boolean,
  dataSepar?: SectionVM
): Evento => {
  const date = dataDatiGenerali?.effectiveDate?.toFormat('yyyy-MM-dd') || '';
  const hours = dataDatiGenerali?.effectiveTime?.toFormat('THHmmssSSS') || '';
  const timestampDecorrenza =
    date || hours
      ? DateTime.fromFormat(`${date || ''} ${hours || ''}`, 'yyyy-MM-dd THHmmssSSS')
      : undefined;

  const lastItem = data[data.length - 1];
  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    // tipoEvento: data[0]?.response || undefined,
    tipoEvento: data[0]?.codStepSuccessivo || undefined,
    codiceStatoEvento: isLastStepEmergency
      ? STATES_ACT.ID_STATE_BOZZA_EMERGENZA
      : data[0]?.codiceStatoEvento || data[0]?.codStepSuccessivo || undefined,
    idAnsc: data[0]?.idAnsc || undefined,
    numeroAtto: data[0]?.numeroAtto || undefined,
    tipoContenuto: data[0]?.tipoContenuto || undefined,
    tipoUseCase: idValore || undefined,
    dataFormazioneAtto: dateFormationAct || undefined,
    descrizioneUseCase: descrizioneValore || undefined,
    flagAusilioInterprete:
      subject?.generality ||
      dataDead ||
      dataMatrimonioAtti ||
      dataSpecificCivilUnion ||
      dataDatiSeparazioniUC ||
      dataSepar
        ? subject?.generality?.isWithInterprete ||
          dataDead?.isWithInterprete ||
          dataMatrimonioAtti?.isWithInterprete ||
          dataSpecificCivilUnion?.isWithInterprete ||
          dataDatiSeparazioniUC?.isWithInterprete ||
          dataSepar?.isWithInterprete
          ? '1'
          : '0'
        : // data[0]?.flagAusilioInterprete || undefined, verificare se ancora necessario
          undefined,
    ruoloOperatore: lastItem.role || undefined,
    noteRitardo: nascituro?.generality?.reasonDelay || undefined,
    tipoDatiProdotti:
      dataCittadinanza?.presentationDocument ||
      dataDatiGeneraliRiconoscimento?.presentationDocument ||
      dataEventoRiconoscimento?.presentationDocument ||
      dataDatiGenerali?.presentationDocument ||
      dataTranscriptionBorn?.presentationDocument ||
      dataSpecificCivilUnion?.presentationDocument ||
      dataMatrimonioAtti?.presentationDocument ||
      undefined,
    riconoscimentoSentenza: dataCittadinanza?.sentenceRecognition || undefined,
    flagSentenzaFiglioInc:
      dataDatiGeneraliRiconoscimento ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_SENT
        ? dataDatiGeneraliRiconoscimento?.isIncestuousSonSentence ||
          dataEventoRiconoscimento?.isIncestuousSonSentence
          ? '1'
          : '0'
        : undefined,
    composizioneCompleta:
      valuesText?.text ||
      dataComposizioneAtto?.actComposition ||
      dataComposizioneAttoDue?.actComposition ||
      testoDelegaUnioneCivile?.actComposition ||
      testoDelegaMatrimonio?.actComposition ||
      undefined,
    flagAnnotazNonCertificabile: dataComposizioneAttoDue
      ? dataComposizioneAttoDue.isNotCertifiable
        ? '1'
        : '0'
      : undefined,
    motivoRecupero: dataDatiGenerali?.reasonRecovery || undefined,
    descrizioneMotivoRecupero: dataDatiGenerali?.descriptionsReasonRecovery || undefined,
    timestampDecorrenza,
    // tipoConsenso:
    //   dataEventoRiconoscimento?.codeSection !== CodeSection.DATI_GENERALI_CONS_ASS_RICO &&
    //   dataEventoRiconoscimento?.codeSection !== CodeSection.DATI_GENERALI_CONS_RICO_SENT
    //     ? dataEventoRiconoscimento?.typologyConsent || undefined
    //     : undefined,
    tipoDichiarante,
    flagCertificatoSemplice:
      dataDatiGenerali?.configuration === ConfigurationType.DGRECUP1
        ? dataDatiGenerali.isSimpleCertificate
          ? '1'
          : '0'
        : undefined,
    flagEstrattoPerRiassunto:
      dataDatiGenerali?.configuration === ConfigurationType.DGRECUP1
        ? dataDatiGenerali.isAbstractForSummary
          ? '1'
          : '0'
        : undefined,
    idAttoCartaceo: dataDatiGenerali?.identifier || undefined,
    flagRedattoNellaCC: dataMatrimonioAtti
      ? dataMatrimonioAtti.configuration === ConfigurationType.MADTSP3
        ? '0'
        : '1'
      : undefined,
  };
};
